import { getCookie, replaceCookie } from "@/utils/utils";
import cookies from "@/config/cookies";

export default {
	readCookies: ({ commit }) => {
		// eraseCookie(cookies.PARTICIPANTS_AGES);
		replaceCookie(cookies.PARTICIPANTS_AGES);
		// number and ages of participants are set on se results page into cookies and when changing in planner search
		const numberOfParticipants_raw = getCookie(cookies.PARTICIPANTS_NUM);
		const participantAges_raw = getCookie(cookies.PARTICIPANTS_AGES);

		if (numberOfParticipants_raw) {
			const numberOfParticipants = parseInt(numberOfParticipants_raw);

			let participantAges;
			if (participantAges_raw) {
				participantAges = JSON.parse(decodeURIComponent(participantAges_raw));
			} else {
				participantAges = Array(numberOfParticipants).fill(18);
			}

			commit("setParticipants", participantAges);
		}
	},
};
